import React from 'react';
import '../styles//EducationSection.css';


const education = [
  {
    schoolName: "Bradley University",
    program: "Business",
    degree: "Masters in Business Administration",
  
  },

{
  schoolName: "Illinois State University",
  program: "Speech Communication",
  degree: "Bachelors",
 
},


{
  schoolName: "Community College of the Air Force",
  program: "Avionics Systems",
  degree: "Associates",
 
}


];

const EducationSection = () => (
  <div className="education-section">
    <h1>Education</h1>
    {education.map((exp, index) => (
      <div className="education" key={index}>
        <div className="education-header">
          <p className="degree">{exp.degree}</p>
          <p className="school-name">{exp.schoolName}</p>
          <p className="program">{exp.program}</p>
          
        </div>
      </div>
 
    ))};
  </div>
);
export default EducationSection;
